import { ArrowForward, NavigateNext } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import ButtonComponent from 'components/design-system/Button/Button';
import Text from 'components/design-system/Text/Text';
import { SinSidebarLayout } from 'layouts/SinSidebarLayout';

export const SkeletonConcederAdministracion = () => {
  return (
    <SinSidebarLayout>
      <div className="bg-white rounded shadow-md p-4 pb-24 sm:px-10 sm:pt-10 relative mb-16">
        <div className="w-4/5 mb-10">
          <Skeleton
            variant="rounded"
            className="w-full h-10 rounded relative z-0 min-w-full mb-4"
          />
          <Skeleton
            variant="rounded"
            className="w-full rounded relative z-0 min-w-full h-16"
          />
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-5 mb-6 md:mb-0">
            <div className="flex items-center justify-between gap-x-2 h-10">
              <Text type="label" className="mb-0 text-uv-secondary-0">
                SOLICITANTE
              </Text>
              <div className="hidden md:block border-t-2 border-uv-secondary-0 border-dashed w-full h-1 mt-0.5"></div>
              <ArrowForward className="hidden md:block text-uv-secondary-0 w-10 h-10 mr-2" />
            </div>
            <div className="mr-12">
              <Skeleton
                variant="rounded"
                className="w-full h-52 rounded relative z-0 min-w-full"
              />
            </div>
          </div>
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center justify-between gap-x-2 h-10">
              <Text type="label" className="mb-0 text-uv-secondary-0">
                SOLICITADO
              </Text>
            </div>
            <Skeleton
              variant="rounded"
              className="w-full h-96 rounded relative z-0 min-w-full"
            />
          </div>
        </div>
        <div className="absolute bottom-0 w-full shadow-md rounded-bl rounded-br bg-white px-10 py-4 border-t left-0">
          <div className="flex justify-between">
            <div></div>
            <ButtonComponent disabled>
              Continuar
              <NavigateNext />
            </ButtonComponent>
          </div>
        </div>
      </div>
    </SinSidebarLayout>
  );
};
